import { render, staticRenderFns } from "./editBatteryBunker.vue?vue&type=template&id=080ece74&scoped=true&"
import script from "./editBatteryBunker.vue?vue&type=script&lang=js&"
export * from "./editBatteryBunker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080ece74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('080ece74')) {
      api.createRecord('080ece74', component.options)
    } else {
      api.reload('080ece74', component.options)
    }
    module.hot.accept("./editBatteryBunker.vue?vue&type=template&id=080ece74&scoped=true&", function () {
      api.rerender('080ece74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chkg/cabinet/dialog/editBatteryBunker.vue"
export default component.exports